import { IconButton } from '@mui/material'
import { darken, styled } from '@mui/material/styles'

export const CircleIconButton = styled(IconButton)<{
  isCondensedWidth?: boolean
}>(({ theme, isCondensedWidth }) => ({
  border: '1px solid #e4e4e4',

  background: 'white',
  ...(isCondensedWidth && {
    border: 'none',
    boxShadow: 'none'
  }),
  '@media (max-height: 500px)': {
    border: 'none',
    boxShadow: 'none',
    width: '38px',
    height: '38px'
  },
  '&:hover': {
    background: theme.palette.background.paper
  }
}))
